import AudioStore from '@/shared/store/audio.store.tsx'

export const getAudioBufferFromFile = async (
  file: File
): Promise<AudioBuffer> => {
  const audioContext = AudioStore.getState().audioContext
  return await fileToAudioBuffer(file, audioContext)
}

const fileToAudioBuffer = async (
  file: File,
  audioContext: AudioContext
): Promise<AudioBuffer> =>
  await new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = (e) => {
      const arrayBuffer = e.target?.result
      if (!(arrayBuffer instanceof ArrayBuffer)) {
        reject(new Error('FileReader result is not an ArrayBuffer.'))
        return
      }
      audioContext
        .decodeAudioData(arrayBuffer)
        .then((audioBuffer) => {
          resolve(audioBuffer)
        })
        .catch((err: unknown) => {
          reject(
            new Error(
              `Error decoding audio data: ${err instanceof Error ? err.message : String(err)}`
            )
          )
        })
    }

    reader.onerror = () => {
      reject(new Error('FileReader failed to read the file.'))
    }

    reader.readAsArrayBuffer(file)
  })
